import {
  connect
} from 'react-redux'
import {
  getSearch,
  getAllSearch,
  resetData
} from '../../actions/InsightsInfo'
import InsightsView from '../../components/InsightsInfo/Index'

const mapStateToProps = (state) => {
  const {
    search_results,
    all_search_results
  } = state.insightsInfo
  return {
    clients: state.app.clients,
    search_results,
    all_search_results
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getSearch: (obj) => {
      dispatch(getSearch(obj))
    },
    getAllSearch: (obj) => {
      dispatch(getAllSearch(obj))
    },
    resetData: () => {
      dispatch(resetData())
    }
  }
}

const InsightsInfo = connect(
  mapStateToProps,
  mapDispatchToProps
)(InsightsView)

export default InsightsInfo;



// WEBPACK FOOTER //
// ./src/containers/InsightsInfo/Index.js